import { AccordionTrigger } from '@talentmesh/ui/components/accordion';
import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

export default function RequestInformationAccordionTrigger({ children }: React.PropsWithChildren) {
    return (
        <AccordionTrigger className={cn('text-foreground bg-alicia rounded-none text-base', 'min-h-14 px-6 py-4')}>
            {children}
        </AccordionTrigger>
    );
}
